import React, { useState } from 'react'
import classnames from 'classnames'
import classes from './index.module.scss'
import * as Assets from '../../assets'
import { IndexedDB } from '@sendum/core'
import { Loader } from '../Loader/Loader'


export const ClearCache = () => {
    const [isLoading, setLoading] = useState<boolean>(false);

    const clearShipmentCache = async () => {
        setLoading(true);
        await IndexedDB.clearCacheData();
        // setLoading(false);

        window.location.reload();
    }

    return (
        <div className={classes.clearShipmentCache}>
            <div
                className={classnames(
                    classes.clearShipmentCache__label,
                    isLoading ? classes.clearShipmentCache__label_disabled : '',
                )}
                onClick={clearShipmentCache}>
                {isLoading && (
                    <img className={classes.clearShipmentCache__loadingImg} alt={''} src={Assets.Loading} />)}
                Clear cache
            </div>
            {isLoading && (
                <div className={classes.clearShipmentCache__backdrop} >
                    <Loader/>
                </div>
            )}
        </div>);
};